/**
 * True when the facet / company id is the Työmarkkinatori aggregate (with or without ö),
 * using NFC so composed vs decomposed Unicode matches logo URL logic.
 */
export function isTyomarkkinatoriCompanyId(companyId: string): boolean {
  const id = companyId.normalize('NFC').toLowerCase().trim();
  return id === 'työmarkkinatori' || id === 'tyomarkkinatori';
}
